
(function(){
  var konf = document.getElementById('wr-konfigurator');
  if(!konf) return;

  var PRICES = {
    "50-50": {"250": 9.50, "500": 17.80, "1000": 34.50},
    "80-20": {"250": 9.70, "500": 18.20, "1000": 35.10},
    "brasilien": {"250": 9.80, "500": 18.50, "1000": 35.80},
    "kolumbien-clasico": {"250": 11.50, "500": 22.50, "1000": 44.00},
    "kolumbien-funky": {"250": 14.00, "500": 26.80, "1000": 52.00},
    "kolumbien-dulce": {"250": 13.50, "500": 24.20},
    "decaf": {"250": 10.80, "500": 20.80}
  };
  var PRODUCT_NAMES = {
    "50-50": "50|50",
    "80-20": "80|20",
    "brasilien": "Brasilien",
    "kolumbien-clasico": "Kolumbien Clasico",
    "kolumbien-funky": "Kolumbien Funky",
    "kolumbien-dulce": "Kolumbien Dulce",
    "decaf": "DECAF"
  };
  var ABO_DISCOUNT = 0.10;
var VARIANT_IDS = {
    "50-50": {"250": 57592863588700, "500": 57592863621468, "1000": 57592863654236},
    "80-20": {"250": 57592864768348, "500": 57592864801116, "1000": 57592864833884},
    "brasilien": {"250": 57592865358172, "500": 57592865390940, "1000": 57592865423708},
    "kolumbien-clasico": {"250": 57592865816924, "500": 57592865849692, "1000": 57592865882460},
    "kolumbien-funky": {"250": 57592866210140, "500": 57592866242908, "1000": 57592866275676},
    "kolumbien-dulce": {"250": 57592867029340, "500": 57592867062108},
    "decaf": {"250": 57592866570588, "500": 57592866603356}
  };
  var FREE_SHIPPING_THRESHOLD = 39.0;
  var SHIPPING_DE = 4.99;
  var SELLING_PLAN_IDS = {
    "weekly":    692781973852,
    "biweekly":  692782006620,
    "monthly":   692782039388,
    "6weeks":    692782072156,
    "2months":   692782104924
  };
  

  var state = { path: null, product: null, size: null, qty: 1, grind: null, interval: null, mix_count: null, mix_bags: [] };
  try { var saved = JSON.parse(localStorage.getItem('wrKonf')); if(saved) Object.assign(state, saved); } catch(e){}

  var stepOrderSingle = ['path','sort','sizemenge','grind','interval','summary'];
  var stepOrderMix    = ['path','mixcount','mixbags','interval','summary'];
  function getStepOrder(){ return state.path === 'mix' ? stepOrderMix : stepOrderSingle; }
  function getStepMax(){ return state.path === 'mix' ? 4 : 5; }
  function getProgressIdx(name){
    if (state.path === 'mix'){
      if (name === 'path') return 1;
      if (name === 'mixcount') return 2;
      if (name === 'mixbags') return 3;
      if (name === 'interval') return 4;
      if (name === 'summary') return 4;
    } else {
      if (name === 'path') return 1;
      if (name === 'sort') return 2;
      if (name === 'sizemenge') return 3;
      if (name === 'grind') return 4;
      if (name === 'interval') return 5;
      if (name === 'summary') return 5;
    }
    return 1;
  }
  // Legacy aliases for any code that still references these:
  var stepOrder = stepOrderSingle;
  var stepProgress = { path:1, sort:2, sizemenge:3, grind:4, interval:5, summary:5, mixcount:2, mixbags:3 };
  var currentStep = 'path';

  var nextBtn = konf.querySelector('.wr-konf-next');
  var backBtn = konf.querySelector('.wr-konf-back');
  var progressFill = konf.querySelector('.wr-progress-fill');
  var stepCurrentEl = konf.querySelector('#wr-step-current');

  function saveState(){ try { localStorage.setItem('wrKonf', JSON.stringify(state)); } catch(e){} }

  function canAdvance(){
    if (currentStep === 'path') return !!state.path;
    if (currentStep === 'sort') return !!state.product;
    if (currentStep === 'sizemenge') return !!state.size && state.qty >= 1;
    if (currentStep === 'grind') return !!state.grind;
    if (currentStep === 'interval') return !!state.interval;
    if (currentStep === 'mixcount') return !!state.mix_count && state.mix_count >= 2 && state.mix_count <= 4;
    if (currentStep === 'mixbags') {
      if (!Array.isArray(state.mix_bags) || state.mix_bags.length !== state.mix_count) return false;
      return state.mix_bags.every(function(b){ return b && b.handle && b.size && b.grind; });
    }
    if (currentStep === 'summary') return false; // summary uses submit button, not next
    return false;
  }

  function updateNext(){
    var ok = canAdvance();
    nextBtn.disabled = !ok;
    nextBtn.classList.toggle('is-ready', ok);
  }

  function fmtEUR(v){
    return v.toFixed(2).replace('.', ',') + ' €';
  }

  function updateSummaryStep(){
    if (state.path === 'mix') return updateSummaryStepMix();
    if (!state.product || !state.size || !state.grind || !state.interval) return;
    var single = document.getElementById('wr-summary-single');
    var mix = document.getElementById('wr-summary-mix');
    if (single) single.hidden = false;
    if (mix) mix.hidden = true;
    var grindLabels = { bohne: 'Ganze Bohne', grob: 'Grob', mittel: 'Mittel', fein: 'Fein' };
    var grindBrews = {
      bohne: 'Alle Brühmethoden',
      grob: 'French Press · Cold Brew',
      mittel: 'Bialetti · Filter · AeroPress · Handfilter',
      fein: 'Siebträger · Vollautomat'
    };
    var intLabels = { weekly: 'Wöchentlich', biweekly: 'Alle 2 Wochen', monthly: 'Monatlich', '6weeks': 'Alle 6 Wochen', '2months': 'Alle 2 Monate' };
    var intDays = { weekly: 7, biweekly: 14, monthly: 30, '6weeks': 42, '2months': 60 };

    // Sorte
    document.getElementById('sum-sort').textContent = PRODUCT_NAMES[state.product];
    document.getElementById('sum-sort-sub').textContent = '';

    // Größe & Menge
    var sizeStr = state.size === '1000' ? '1 kg' : state.size + ' g';
    document.getElementById('sum-size').textContent = state.qty + ' × ' + sizeStr + ' pro Lieferung';
    var totalG = parseInt(state.size, 10) * state.qty;
    var weightStr;
    if (totalG >= 1000){
      var kg = totalG / 1000;
      weightStr = (kg % 1 === 0 ? kg.toString() : kg.toFixed(2).replace(/0+$/,'').replace(/\.$/,'').replace('.', ',')) + ' kg';
    } else {
      weightStr = totalG + ' g';
    }
    document.getElementById('sum-size-sub').textContent = 'Gesamtgewicht: ' + weightStr;

    // Mahlgrad
    document.getElementById('sum-grind').textContent = grindLabels[state.grind];
    document.getElementById('sum-grind-sub').textContent = grindBrews[state.grind];

    // Intervall
    document.getElementById('sum-interval').textContent = intLabels[state.interval];
    document.getElementById('sum-interval-sub').textContent = 'alle ' + intDays[state.interval] + ' Tage';

    // Preise
    var unit = PRICES[state.product][state.size];
    var subtotal = unit * state.qty;
    var discount = subtotal * ABO_DISCOUNT;
    var finalPrice = subtotal - discount;
    document.getElementById('sum-orig').textContent = fmtEUR(subtotal);
    document.getElementById('sum-discount').textContent = '−' + fmtEUR(discount);
    document.getElementById('sum-final').textContent = fmtEUR(finalPrice);

    // Versand
    var shipEl = document.getElementById('sum-shipping');
    if (finalPrice >= FREE_SHIPPING_THRESHOLD){
      shipEl.textContent = 'kostenlos';
      shipEl.classList.remove('is-paid');
    } else {
      shipEl.textContent = fmtEUR(SHIPPING_DE) + ' (frei ab ' + fmtEUR(FREE_SHIPPING_THRESHOLD) + ')';
      shipEl.classList.add('is-paid');
    }
  }

  function updateIntervalStep(){
    var eyebrow = document.getElementById('wr-int-eyebrow');
    if (eyebrow){
      if (state.path === 'mix'){
        eyebrow.textContent = 'Für deinen Wunderlich Mix';
      } else if (state.product && PRODUCT_NAMES[state.product]){
        eyebrow.textContent = 'Für ' + PRODUCT_NAMES[state.product];
      }
    }

    var INTERVAL_DAYS = { weekly: 7, biweekly: 14, monthly: 30, '6weeks': 42, '2months': 60 };
    var totalG = 0;
    if (state.path === 'mix' && Array.isArray(state.mix_bags)){
      totalG = state.mix_bags.reduce(function(s, b){
        if (!b || !b.size) return s;
        var bq = (b.qty && b.qty >= 1) ? b.qty : 1;
        return s + parseInt(b.size,10) * bq;
      }, 0);
    } else if (state.size && state.qty){
      totalG = parseInt(state.size, 10) * state.qty;
    }

    if (totalG > 0){
      konf.querySelectorAll('.wr-int-tile').forEach(function(t){
        var iv = t.dataset.interval;
        var days = INTERVAL_DAYS[iv];
        var hintEl = t.querySelector('.wr-int-hint');
        if (!hintEl || !days) return;
        var gPerDay = totalG / days;
        var rounded;
        if (gPerDay < 1)      rounded = gPerDay.toFixed(2).replace('.', ',');
        else if (gPerDay < 10) rounded = gPerDay.toFixed(1).replace('.', ',');
        else                  rounded = Math.round(gPerDay).toString();
        hintEl.textContent = '~ ' + rounded + ' g pro Tag';
      });
    } else {
      konf.querySelectorAll('.wr-int-tile').forEach(function(t){
        var hintEl = t.querySelector('.wr-int-hint');
        if (hintEl && hintEl.dataset.defaultHint) hintEl.textContent = hintEl.dataset.defaultHint;
      });
    }

    konf.querySelectorAll('.wr-int-tile').forEach(function(t){
      t.classList.toggle('is-selected', t.dataset.interval === state.interval);
    });
    updateNext();
  }

  function updateGrindStep(){
    var eyebrow = document.getElementById('wr-grind-eyebrow');
    if (eyebrow && state.product && PRODUCT_NAMES[state.product]){
      eyebrow.textContent = 'Für ' + PRODUCT_NAMES[state.product];
    }
    konf.querySelectorAll('.wr-grind-tile').forEach(function(t){
      t.classList.toggle('is-selected', t.dataset.grind === state.grind);
    });
    updateNext();
  }

  function updateSizeStep(){
    // Update title eyebrow to show product
    var eyebrow = document.getElementById('wr-sm-eyebrow');
    if (eyebrow && state.product && PRODUCT_NAMES[state.product]){
      eyebrow.textContent = 'Für ' + PRODUCT_NAMES[state.product];
    }

    // Enable/disable 1kg tile
    var sizes = PRICES[state.product] || {};
    konf.querySelectorAll('.wr-size-tile').forEach(function(t){
      var sz = t.dataset.size;
      var avail = sizes[sz] !== undefined;
      t.disabled = !avail;
      if (!avail && state.size === sz) state.size = null;
      t.classList.toggle('is-selected', t.dataset.size === state.size);
    });

    // Restore qty
    if (!state.qty || state.qty < 1) state.qty = 1;
    if (state.qty > 10) state.qty = 10;
    konf.querySelector('.wr-menge-input').value = state.qty;
    updateMengeButtons();

    updateSummary();
  }

  function updateMengeButtons(){
    konf.querySelector('.wr-menge-btn[data-action="dec"]').disabled = state.qty <= 1;
    konf.querySelector('.wr-menge-btn[data-action="inc"]').disabled = state.qty >= 10;
  }

  function updateSummary(){
    var pEl = konf.querySelector('#wr-sm-product');
    var wEl = konf.querySelector('#wr-sm-total-weight');
    var origEl = konf.querySelector('#wr-sm-orig');
    var finEl = konf.querySelector('#wr-sm-final');
    var discEl = konf.querySelector('#wr-sm-discount');
    var savEl = konf.querySelector('#wr-sm-savings');

    if (!state.product || !state.size){
      pEl.textContent = '—'; wEl.textContent = '—';
      origEl.textContent = ''; finEl.textContent = '—';
      discEl.style.display = 'none';
      updateNext();
      return;
    }
    var unit = PRICES[state.product][state.size];
    var qty = state.qty;
    var sub = unit * qty;
    var disc = sub * ABO_DISCOUNT;
    var fin = sub - disc;
    var sizeLabel = state.size === '1000' ? '1 kg' : state.size + ' g';

    pEl.textContent = qty + ' × ' + sizeLabel;
    var totalGrams = parseInt(state.size, 10) * qty;
    var weightLabel = totalGrams >= 1000 ? (totalGrams/1000).toFixed(totalGrams % 1000 === 0 ? 0 : 2).replace('.', ',') + ' kg' : totalGrams + ' g';
    wEl.textContent = weightLabel;
    origEl.textContent = fmtEUR(sub);
    finEl.textContent = fmtEUR(fin);
    discEl.style.display = '';
    savEl.textContent = fmtEUR(disc);
    updateNext();
  }

  // ============================================================
  // MIX-PFAD helpers
  // ============================================================
  var MIX_SORT_OPTIONS = [
    { handle: '50-50',              label: '50|50',              eyebrow: 'Espresso Blend' },
    { handle: '80-20',              label: '80|20',              eyebrow: 'Espresso Blend' },
    { handle: 'brasilien',          label: 'Brasilien',          eyebrow: 'Single Origin' },
    { handle: 'kolumbien-clasico',  label: 'Kolumbien Clasico',  eyebrow: 'Single Origin' },
    { handle: 'kolumbien-funky',    label: 'Kolumbien Funky',    eyebrow: 'Single Origin' },
    { handle: 'kolumbien-dulce',    label: 'Kolumbien Dulce',    eyebrow: 'Single Origin' },
    { handle: 'decaf',              label: 'DECAF',              eyebrow: 'Entkoffeiniert' }
  ];
  var GRIND_OPTIONS = [
    { v: 'bohne',  label: 'Ganze Bohne' },
    { v: 'grob',   label: 'Grob' },
    { v: 'mittel', label: 'Mittel' },
    { v: 'fein',   label: 'Fein' }
  ];
  var SIZE_OPTIONS_MIX = ['250','500','1000'];

  function updateMixCountStep(){
    konf.querySelectorAll('.wr-mixcount-tile').forEach(function(t){
      t.classList.toggle('is-selected', parseInt(t.dataset.count,10) === state.mix_count);
    });
    updateNext();
  }

  function bagSizeAvailable(handle, size){
    var p = PRICES[handle] || {};
    return p[size] !== undefined;
  }

  function renderMixBagsList(){
    var list = document.getElementById('wr-mixbags-list');
    if (!list) return;
    var count = state.mix_count || 0;
    // Ensure mix_bags has exactly `count` slots, each with handle/size/grind/qty
    if (!Array.isArray(state.mix_bags)) state.mix_bags = [];
    while (state.mix_bags.length < count) state.mix_bags.push({ handle: null, size: null, grind: null, qty: 1 });
    if (state.mix_bags.length > count) state.mix_bags.length = count;
    // Backfill qty for legacy bags without it
    state.mix_bags.forEach(function(b){ if (!b.qty || b.qty < 1) b.qty = 1; if (b.qty > 10) b.qty = 10; });

    var html = '';
    for (var i = 0; i < count; i++){
      var bag = state.mix_bags[i] || {};
      var sortOpts = '<option value="">&mdash; Sorte w&auml;hlen &mdash;</option>';
      for (var j = 0; j < MIX_SORT_OPTIONS.length; j++){
        var o = MIX_SORT_OPTIONS[j];
        var sel = (bag.handle === o.handle) ? ' selected' : '';
        sortOpts += '<option value="' + o.handle + '"' + sel + '>' + o.label + ' &mdash; ' + o.eyebrow + '</option>';
      }
      var sizeBtns = '';
      for (var k = 0; k < SIZE_OPTIONS_MIX.length; k++){
        var sz = SIZE_OPTIONS_MIX[k];
        var lbl = (sz === '1000') ? '1&thinsp;kg' : sz + '&thinsp;g';
        var isSel = (bag.size === sz) ? ' is-selected' : '';
        // Only mark as unavailable if a sort IS picked AND this size doesn't exist for it
        var sortPicked = !!bag.handle;
        var avail = sortPicked ? bagSizeAvailable(bag.handle, sz) : true;
        var isDis = (sortPicked && !avail) ? ' is-unavailable' : '';
        var disAttr = (!sortPicked || !avail) ? ' disabled' : '';
        sizeBtns += '<button type="button" class="wr-bagrow-mini' + isSel + isDis + '" data-bagidx="' + i + '" data-field="size" data-value="' + sz + '"' + disAttr + '>' + lbl + '</button>';
      }
      var grindBtns = '';
      for (var m = 0; m < GRIND_OPTIONS.length; m++){
        var g = GRIND_OPTIONS[m];
        var gSel = (bag.grind === g.v) ? ' is-selected' : '';
        grindBtns += '<button type="button" class="wr-bagrow-mini' + gSel + '" data-bagidx="' + i + '" data-field="grind" data-value="' + g.v + '">' + g.label + '</button>';
      }
      // Price per bag (× qty)
      var bagQty = (bag.qty && bag.qty >= 1) ? bag.qty : 1;
      var priceStr = '&mdash;';
      var discStr = '';
      var qtyHint = '';
      if (bag.handle && bag.size && PRICES[bag.handle] && PRICES[bag.handle][bag.size] !== undefined){
        var unit = PRICES[bag.handle][bag.size];
        var unitDisc = unit * (1 - ABO_DISCOUNT);
        var lineDisc = unitDisc * bagQty;
        var lineOrig = unit * bagQty;
        priceStr = fmtEUR(lineDisc);
        discStr = '<span class="wr-bagrow-price-orig">' + fmtEUR(lineOrig) + '</span>';
        if (bagQty > 1) qtyHint = '<span class="wr-bagrow-price-qty">' + bagQty + '× ' + fmtEUR(unitDisc) + ' =</span>';
      }
      var complete = bag.handle && bag.size && bag.grind;
      var statusText = complete ? 'Bag konfiguriert' : 'Sorte, Gr&ouml;&szlig;e &amp; Mahlgrad w&auml;hlen';
      var mengeBtns = '<div class="wr-bagrow-menge' + (bagQty > 1 ? ' is-active' : '') + '">'
                    +   '<button type="button" class="wr-bagrow-menge-btn" data-bagidx="' + i + '" data-menge="dec" aria-label="Menge verringern"' + (bagQty <= 1 ? ' disabled' : '') + '>&minus;</button>'
                    +   '<span class="wr-bagrow-menge-val">' + bagQty + '</span>'
                    +   '<button type="button" class="wr-bagrow-menge-btn" data-bagidx="' + i + '" data-menge="inc" aria-label="Menge erh&ouml;hen"' + (bagQty >= 10 ? ' disabled' : '') + '>+</button>'
                    + '</div>';
      html += '<div class="wr-bagrow' + (complete ? ' is-complete' : '') + '" data-bagidx="' + i + '">'
            + '<div class="wr-bagrow-head">'
            +   '<span class="wr-bagrow-num">Bag ' + (i+1) + '</span>'
            +   '<span class="wr-bagrow-status">' + statusText + '</span>'
            + '</div>'
            + '<div class="wr-bagrow-body">'
            +   '<div class="wr-bagrow-field wr-bagrow-field-sort">'
            +     '<label class="wr-bagrow-flabel">Sorte</label>'
            +     '<div class="wr-bagrow-select-wrap"><select class="wr-bagrow-select" data-bagidx="' + i + '" data-field="handle">' + sortOpts + '</select></div>'
            +   '</div>'
            +   '<div class="wr-bagrow-field wr-bagrow-field-size">'
            +     '<label class="wr-bagrow-flabel">Gr&ouml;&szlig;e</label>'
            +     '<div class="wr-bagrow-minis">' + sizeBtns + '</div>'
            +   '</div>'
            +   '<div class="wr-bagrow-field wr-bagrow-field-grind">'
            +     '<label class="wr-bagrow-flabel">Mahlgrad</label>'
            +     '<div class="wr-bagrow-minis">' + grindBtns + '</div>'
            +   '</div>'
            +   '<div class="wr-bagrow-field wr-bagrow-field-menge">'
            +     '<label class="wr-bagrow-flabel">Menge</label>'
            +     mengeBtns
            +   '</div>'
            + '</div>'
            + '<div class="wr-bagrow-price">'
            +   '<span class="wr-bagrow-price-label">Preis</span>'
            +   '<span class="wr-bagrow-price-val">' + qtyHint + discStr + priceStr + '</span>'
            + '</div>'
            + '</div>';
    }
    list.innerHTML = html;

    // Wire up handlers
    list.querySelectorAll('.wr-bagrow-select').forEach(function(sel){
      sel.addEventListener('change', function(){
        var idx = parseInt(sel.dataset.bagidx, 10);
        state.mix_bags[idx].handle = sel.value || null;
        // If new sort doesn't support current size, clear size
        if (state.mix_bags[idx].handle && state.mix_bags[idx].size && !bagSizeAvailable(state.mix_bags[idx].handle, state.mix_bags[idx].size)){
          state.mix_bags[idx].size = null;
        }
        saveState();
        renderMixBagsList();
        updateMixBagsTotals();
        updateNext();
      });
    });
    list.querySelectorAll('.wr-bagrow-mini').forEach(function(btn){
      btn.addEventListener('click', function(){
        if (btn.disabled) return;
        var idx = parseInt(btn.dataset.bagidx, 10);
        var f = btn.dataset.field;
        state.mix_bags[idx][f] = btn.dataset.value;
        saveState();
        renderMixBagsList();
        updateMixBagsTotals();
        updateNext();
      });
    });
    // Menge -/+ buttons per bag
    list.querySelectorAll('.wr-bagrow-menge-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        if (btn.disabled) return;
        var idx = parseInt(btn.dataset.bagidx, 10);
        var dir = btn.dataset.menge;
        var b = state.mix_bags[idx];
        if (!b.qty || b.qty < 1) b.qty = 1;
        if (dir === 'inc' && b.qty < 10) b.qty += 1;
        else if (dir === 'dec' && b.qty > 1) b.qty -= 1;
        saveState();
        renderMixBagsList();
        updateMixBagsTotals();
        updateNext();
      });
    });
  }

  function updateMixBagsTotals(){
    var sub = 0;
    if (Array.isArray(state.mix_bags)){
      state.mix_bags.forEach(function(b){
        if (b && b.handle && b.size && PRICES[b.handle] && PRICES[b.handle][b.size] !== undefined){
          var bq = (b.qty && b.qty >= 1) ? b.qty : 1;
          sub += PRICES[b.handle][b.size] * bq;
        }
      });
    }
    var disc = sub * ABO_DISCOUNT;
    var fin = sub - disc;
    var o = document.getElementById('wr-mixbags-orig');
    var d = document.getElementById('wr-mixbags-discount');
    var t = document.getElementById('wr-mixbags-final');
    if (o) o.textContent = sub > 0 ? fmtEUR(sub) : '—';
    if (d) d.textContent = sub > 0 ? '−' + fmtEUR(disc) : '—';
    if (t) t.textContent = sub > 0 ? fmtEUR(fin) : '—';
  }

  function updateMixBagsStep(){
    renderMixBagsList();
    updateMixBagsTotals();
  }

  function updateSummaryStepMix(){
    if (state.path !== 'mix') return;
    var grindLabels = { bohne: 'Ganze Bohne', grob: 'Grob', mittel: 'Mittel', fein: 'Fein' };
    var intLabels = { weekly: 'Wöchentlich', biweekly: 'Alle 2 Wochen', monthly: 'Monatlich', '6weeks': 'Alle 6 Wochen', '2months': 'Alle 2 Monate' };
    var intDays = { weekly: 7, biweekly: 14, monthly: 30, '6weeks': 42, '2months': 60 };

    // Toggle single vs mix card visibility
    var single = document.getElementById('wr-summary-single');
    var mix = document.getElementById('wr-summary-mix');
    if (single) single.hidden = true;
    if (mix) mix.hidden = false;

    // Anzahl Bags
    var countEl = document.getElementById('sum-mix-count');
    var countSubEl = document.getElementById('sum-mix-count-sub');
    if (countEl) countEl.textContent = state.mix_count + ' Bags';
    if (countSubEl){
      var totalG2 = 0;
      if (Array.isArray(state.mix_bags)){
        totalG2 = state.mix_bags.reduce(function(s, b){
          if (!b || !b.size) return s;
          var bq2 = (b.qty && b.qty >= 1) ? b.qty : 1;
          return s + parseInt(b.size,10) * bq2;
        }, 0);
      }
      var weightStr2;
      if (totalG2 >= 1000){
        var kg2 = totalG2 / 1000;
        weightStr2 = (kg2 % 1 === 0 ? kg2.toString() : kg2.toFixed(2).replace(/0+$/,'').replace(/\.$/,'').replace('.', ',')) + ' kg';
      } else {
        weightStr2 = totalG2 + ' g';
      }
      countSubEl.textContent = 'Gesamtgewicht: ' + weightStr2;
    }

    // Bag-Liste (mit qty)
    var listEl = document.getElementById('sum-mix-bags');
    if (listEl){
      var html = '';
      if (Array.isArray(state.mix_bags)){
        for (var i = 0; i < state.mix_bags.length; i++){
          var b = state.mix_bags[i] || {};
          var bq = (b.qty && b.qty >= 1) ? b.qty : 1;
          var sortName = (b.handle && PRODUCT_NAMES[b.handle]) || '—';
          var sizeLbl = b.size === '1000' ? '1 kg' : (b.size + ' g');
          var grindLbl = grindLabels[b.grind] || '—';
          var qtyLbl = (bq > 1) ? (bq + '× ') : '';
          var bagPrice = '';
          if (b.handle && b.size && PRICES[b.handle] && PRICES[b.handle][b.size] !== undefined){
            bagPrice = fmtEUR(PRICES[b.handle][b.size] * (1 - ABO_DISCOUNT) * bq);
          }
          html += '<div class="wr-summary-bag">'
                + '<div class="wr-summary-bag-info">'
                +   '<span class="wr-summary-bag-num">Bag ' + (i+1) + '</span>'
                +   '<span class="wr-summary-bag-main">' + qtyLbl + sortName + ' &middot; ' + sizeLbl + ' &middot; ' + grindLbl + '</span>'
                + '</div>'
                + '<span class="wr-summary-bag-price">' + bagPrice + '</span>'
                + '</div>';
        }
      }
      html += '<div class="wr-summary-bag-edit"><button class="wr-summary-edit" data-jump-to="mixbags" type="button">Bags &auml;ndern</button></div>';
      listEl.innerHTML = html;
      // Re-wire jump-to on the newly created edit button
      listEl.querySelectorAll('.wr-summary-edit').forEach(function(btn){
        btn.addEventListener('click', function(){
          var target = btn.dataset.jumpTo;
          if (target) showStep(target);
        });
      });
    }

    // Intervall
    var miEl = document.getElementById('sum-mix-interval');
    var miSubEl = document.getElementById('sum-mix-interval-sub');
    if (miEl) miEl.textContent = intLabels[state.interval] || '—';
    if (miSubEl) miSubEl.textContent = state.interval && intDays[state.interval] ? ('alle ' + intDays[state.interval] + ' Tage') : '—';

    // Prices (reuse the existing wr-summary-price block IDs)
    var subM = 0;
    if (Array.isArray(state.mix_bags)){
      state.mix_bags.forEach(function(b){
        if (b && b.handle && b.size && PRICES[b.handle] && PRICES[b.handle][b.size] !== undefined){
          var bq3 = (b.qty && b.qty >= 1) ? b.qty : 1;
          subM += PRICES[b.handle][b.size] * bq3;
        }
      });
    }
    var discM = subM * ABO_DISCOUNT;
    var finM = subM - discM;
    var origMEl = document.getElementById('sum-orig');
    var discMEl = document.getElementById('sum-discount');
    var finMEl = document.getElementById('sum-final');
    if (origMEl) origMEl.textContent = fmtEUR(subM);
    if (discMEl) discMEl.textContent = '−' + fmtEUR(discM);
    if (finMEl) finMEl.textContent = fmtEUR(finM);

    var shipMEl = document.getElementById('sum-shipping');
    if (shipMEl){
      if (finM >= FREE_SHIPPING_THRESHOLD){
        shipMEl.textContent = 'kostenlos';
        shipMEl.classList.remove('is-paid');
      } else {
        shipMEl.textContent = fmtEUR(SHIPPING_DE) + ' (frei ab ' + fmtEUR(FREE_SHIPPING_THRESHOLD) + ')';
        shipMEl.classList.add('is-paid');
      }
    }
  }

  // Click handlers for mixcount tiles
  konf.querySelectorAll('.wr-mixcount-tile').forEach(function(tile){
    tile.addEventListener('click', function(){
      var n = parseInt(tile.dataset.count, 10);
      state.mix_count = n;
      // (Re)initialize mix_bags array length without wiping existing entries when shrinking/growing
      if (!Array.isArray(state.mix_bags)) state.mix_bags = [];
      while (state.mix_bags.length < n) state.mix_bags.push({ handle: null, size: null, grind: null, qty: 1 });
      if (state.mix_bags.length > n) state.mix_bags.length = n;
      konf.querySelectorAll('.wr-mixcount-tile').forEach(function(t){
        t.classList.toggle('is-selected', parseInt(t.dataset.count,10) === state.mix_count);
      });
      saveState(); updateNext();
    });
  });

  // Restore mixcount selection if state has one
  if (state.mix_count){
    konf.querySelectorAll('.wr-mixcount-tile').forEach(function(t){
      t.classList.toggle('is-selected', parseInt(t.dataset.count,10) === state.mix_count);
    });
  }

  // For Single path: if returning to summary, make sure single card is visible and mix is hidden
  // (the inverse is handled in updateSummaryStepMix). Patch the Single summary head to toggle.

  function showStep(name){
    currentStep = name;
    konf.querySelectorAll('.wr-step').forEach(function(s){ s.hidden = (s.dataset.step !== name); });
    var idx = getProgressIdx(name);
    var max = getStepMax();
    progressFill.style.width = (idx / max * 100) + '%';
    stepCurrentEl.textContent = idx;
    var totalEl = konf.querySelector('#wr-step-total');
    if (totalEl) totalEl.textContent = max;
    backBtn.classList.toggle('is-active', idx > 1);
    if (name === 'sizemenge') updateSizeStep();
    if (name === 'grind') updateGrindStep();
    if (name === 'interval') updateIntervalStep();
    if (name === 'summary') updateSummaryStep();
    if (name === 'mixcount') updateMixCountStep();
    if (name === 'mixbags') updateMixBagsStep();
    nextBtn.style.display = (name === 'summary') ? 'none' : '';
    updateNext();
    konf.scrollIntoView({ behavior:'smooth', block:'start' });
  }

  // === Event Listeners ===

  // Path
  konf.querySelectorAll('.wr-path-card').forEach(function(card){
    card.addEventListener('click', function(){
      var prev = state.path;
      state.path = card.dataset.path;
      // when switching path, clear non-path-specific selections to avoid stale state
      if (prev !== state.path){
        if (state.path === 'mix'){
          state.product = null; state.size = null; state.qty = 1; state.grind = null;
        } else {
          state.mix_count = null; state.mix_bags = [];
        }
      }
      konf.querySelectorAll('.wr-path-card').forEach(function(c){ c.classList.toggle('is-selected', c.dataset.path === state.path); });
      saveState(); updateNext();
    });
  });

  // Sort
  konf.querySelectorAll('.wr-sort-tile').forEach(function(tile){
    tile.addEventListener('click', function(e){
      if (e.target.closest('.wr-sort-tip-link')) return;
      state.product = tile.dataset.handle;
      konf.querySelectorAll('.wr-sort-tile').forEach(function(t){ t.classList.toggle('is-selected', t.dataset.handle === state.product); });
      saveState(); updateNext();
    });
  });

  // Size tiles
  konf.querySelectorAll('.wr-size-tile').forEach(function(tile){
    tile.addEventListener('click', function(){
      if (tile.disabled) return;
      state.size = tile.dataset.size;
      konf.querySelectorAll('.wr-size-tile').forEach(function(t){ t.classList.toggle('is-selected', t.dataset.size === state.size); });
      saveState(); updateSummary();
    });
  });

  // Menge stepper
  konf.querySelectorAll('.wr-menge-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var act = btn.dataset.action;
      if (act === 'dec' && state.qty > 1) state.qty -= 1;
      if (act === 'inc' && state.qty < 10) state.qty += 1;
      konf.querySelector('.wr-menge-input').value = state.qty;
      updateMengeButtons(); updateSummary(); saveState();
    });
  });
  konf.querySelector('.wr-menge-input').addEventListener('input', function(){
    var v = parseInt(this.value, 10);
    if (isNaN(v) || v < 1) v = 1;
    if (v > 10) v = 10;
    state.qty = v;
    this.value = v;
    updateMengeButtons(); updateSummary(); saveState();
  });

  // Mahlgrad
  konf.querySelectorAll('.wr-grind-tile').forEach(function(tile){
    tile.addEventListener('click', function(){
      state.grind = tile.dataset.grind;
      konf.querySelectorAll('.wr-grind-tile').forEach(function(t){ t.classList.toggle('is-selected', t.dataset.grind === state.grind); });
      saveState(); updateNext();
    });
  });

  // Intervall
  konf.querySelectorAll('.wr-int-tile').forEach(function(tile){
    tile.addEventListener('click', function(){
      state.interval = tile.dataset.interval;
      konf.querySelectorAll('.wr-int-tile').forEach(function(t){ t.classList.toggle('is-selected', t.dataset.interval === state.interval); });
      saveState(); updateNext();
    });
  });

  // Summary: Edit-Jumps + Submit
  konf.querySelectorAll('.wr-summary-edit').forEach(function(btn){
    btn.addEventListener('click', function(){
      var target = btn.dataset.jumpTo;
      if (target) showStep(target);
    });
  });

  var submitBtn = document.getElementById('wr-submit-btn');
  if (submitBtn){
    submitBtn.addEventListener('click', function(){
      if (submitBtn.classList.contains('is-loading')) return;
      var errEl = document.getElementById('wr-submit-error');
      errEl.classList.remove('is-visible');

      var grindLabels = { bohne: 'Ganze Bohne', grob: 'Grob', mittel: 'Mittel', fein: 'Fein' };
      var intLabels = { weekly: 'Wöchentlich', biweekly: 'Alle 2 Wochen', monthly: 'Monatlich', '6weeks': 'Alle 6 Wochen', '2months': 'Alle 2 Monate' };
      var intDays = { weekly: 7, biweekly: 14, monthly: 30, '6weeks': 42, '2months': 60 };

      var sellingPlan = SELLING_PLAN_IDS[state.interval];
      if (!sellingPlan){
        errEl.textContent = 'Intervall nicht gefunden. Bitte erneut versuchen.';
        errEl.classList.add('is-visible');
        return;
      }

      var items = [];
      if (state.path === 'mix'){
        if (!Array.isArray(state.mix_bags) || state.mix_bags.length !== state.mix_count){
          errEl.textContent = 'Bag-Konfiguration unvollständig. Bitte erneut versuchen.';
          errEl.classList.add('is-visible');
          return;
        }
        for (var i = 0; i < state.mix_bags.length; i++){
          var b = state.mix_bags[i];
          var vmapM = VARIANT_IDS[b.handle] || {};
          var vidM = vmapM[b.size];
          if (!vidM){
            errEl.textContent = 'Variante für Bag ' + (i+1) + ' (' + (PRODUCT_NAMES[b.handle] || b.handle) + ' ' + b.size + 'g) nicht gefunden.';
            errEl.classList.add('is-visible');
            return;
          }
          var bqSub = (b.qty && b.qty >= 1) ? b.qty : 1;
          items.push({
            id: vidM,
            quantity: bqSub,
            selling_plan: sellingPlan,
            properties: {
              '_Wunderlich-Abo': 'Wunderlich Mix',
              'Mahlgrad': grindLabels[b.grind]
            }
          });
        }
      } else {
        var vmap = VARIANT_IDS[state.product] || {};
        var variantId = vmap[state.size];
        if (!variantId){
          errEl.textContent = 'Variante nicht gefunden. Bitte erneut versuchen.';
          errEl.classList.add('is-visible');
          return;
        }
        items.push({
          id: variantId,
          quantity: state.qty,
          selling_plan: sellingPlan,
          properties: {
            '_Wunderlich-Abo': 'Lieblings-Sorte',
            'Mahlgrad': grindLabels[state.grind]
          }
        });
      }

      submitBtn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r){ return r.json().then(function(data){ return { ok: r.ok, status: r.status, data: data }; }); })
      .then(function(res){
        if (!res.ok || (res.data && res.data.status && res.data.status >= 400)){
          var msg = (res.data && res.data.description) || (res.data && res.data.message) || 'Cart-Fehler (Status ' + res.status + ')';
          throw new Error(msg);
        }
        /* keep wrKonf so user can return and edit */
        window.location.href = '/checkout';
      })
      .catch(function(err){
        submitBtn.classList.remove('is-loading');
        errEl.textContent = 'Hoppla — ' + err.message + '. Bitte erneut versuchen oder /pages/hossenhaus#anfrage kontaktieren.';
        errEl.classList.add('is-visible');
      });
    });
  }

  // Next
  nextBtn.addEventListener('click', function(){
    if(!canAdvance()) return;
    if (currentStep === 'path'){
      if (state.path === 'single') showStep('sort');
      else if (state.path === 'mix') showStep('mixcount');
    } else if (currentStep === 'sort'){
      showStep('sizemenge');
    } else if (currentStep === 'sizemenge'){
      showStep('grind');
    } else if (currentStep === 'grind'){
      showStep('interval');
    } else if (currentStep === 'mixcount'){
      showStep('mixbags');
    } else if (currentStep === 'mixbags'){
      showStep('interval');
    } else if (currentStep === 'interval'){
      showStep('summary');
    }
  });

  // Back
  backBtn.addEventListener('click', function(){
    var order = getStepOrder();
    var idx = order.indexOf(currentStep);
    if (idx > 0) showStep(order[idx - 1]);
  });

  // Restore visual state
  if (state.path) konf.querySelectorAll('.wr-path-card').forEach(function(c){ c.classList.toggle('is-selected', c.dataset.path === state.path); });
  if (state.product) konf.querySelectorAll('.wr-sort-tile').forEach(function(t){ t.classList.toggle('is-selected', t.dataset.handle === state.product); });
  if (state.grind) konf.querySelectorAll('.wr-grind-tile').forEach(function(t){ t.classList.toggle('is-selected', t.dataset.grind === state.grind); });
  if (state.interval) konf.querySelectorAll('.wr-int-tile').forEach(function(t){ t.classList.toggle('is-selected', t.dataset.interval === state.interval); });

  // Smart initial step
  if (state.path === 'mix'){
    if (state.interval && state.mix_count && Array.isArray(state.mix_bags) && state.mix_bags.length === state.mix_count && state.mix_bags.every(function(b){ return b && b.handle && b.size && b.grind; })){
      showStep('summary');
    } else if (state.mix_count){
      showStep('mixbags');
    } else {
      showStep('mixcount');
    }
  } else if (state.product){
    if (!state.path) state.path = 'single';
    if (state.interval && state.grind && state.size) showStep('summary');
    else if (state.grind) showStep('grind');
    else if (state.size) showStep('sizemenge');
    else showStep('sort');
  } else if (state.path){
    showStep('path');
  } else {
    showStep('path');
  }
})();
